const Know=[
{name:"CONOSCENZE METALLI", site:"https://files.avernum.org/manuali/51d57696803b6e02227be3649e02dc32.pdf"},
{name:"CONOSCENZE ALCHIMIA", site:"https://files.avernum.org/manuali/421032bc71d0b0e46617b038470ae366.pdf"},
{name:"CONOSCENZE ERBORISTERIA", site:"https://files.avernum.org/manuali/38e368a9fea4950e166953ee9f74d683.pdf"},
{name:"CONOSCENZE GEOGRAFIA", site:"https://files.avernum.org/manuali/a8b283141b18537a60939ae9f2742041.pdf"},
{name:"CONOSCENZE MITI E LEGGENDE", site:"https://files.avernum.org/manuali/267da3a21e0aa127035c3025237bf0ca.pdf"},
{name:"CONOSCENZE MEDICINA", site:"https://files.avernum.org/manuali/f30123380a740f9b577330bb202c74fe.pdf"},
{name:"CONOSCENZE LINGUE", site:""}];

export {Know}